module.exports = __webpack_public_path__ + "img/innovation-500x500.fd5057d9.png";